import * as React from 'react';
import { ActivityAction, ActivityResourceName } from '@pec/aion-ui-core/interfaces/activities';
import { Connect } from './Connect';
import { ContractorManagementSectionContainer } from '../../containers/Nav/ContractorManagementSection';
import { DeepReadonly } from 'utility-types';
import { EsignatureContainer } from '../../containers/Nav/Esignature';
import { IOrganization, OrganizationFeature } from '@pec/aion-ui-core/interfaces/organization';
import { Location } from 'history';
import { ReportsSectionContainer } from '../../containers/Nav/ReportsSection';
import { SubcontractorManagementContainer } from '../../containers/Nav/SubcontractorManagement';
import { TrainingSection } from './TrainingSection';
import { VerisourceOQNavigation } from './VerisourceOQNavigation';

const { Read, Manage } = ActivityAction;
const {
  Reports,
  BusinessUnits,
  Scoring,
  Organizations,
  Releases,
  Notifications,
  SafetyProgramRequirementClients,
  ContractorReviews,
  Subcontractors,
  ActivityFeed
} = ActivityResourceName;
const { Esignature, VeriforceConnect, Subcontractor } = OrganizationFeature;

export type Props = {
  organization: DeepReadonly<IOrganization>;
  hasOrganizationPermission: (action: ActivityAction, resourceName: ActivityResourceName) => boolean;
  location: Location;
  isChasClient?: boolean;
};

export const ClientLinks: React.FC<Props> = ({ organization, hasOrganizationPermission, location, isChasClient }) => {
  const { features } = organization;
  const showContractorManagementSection =
    hasOrganizationPermission(Read, Organizations) ||
    hasOrganizationPermission(Manage, Releases) ||
    hasOrganizationPermission(Read, Notifications) ||
    hasOrganizationPermission(Manage, BusinessUnits) ||
    hasOrganizationPermission(Manage, SafetyProgramRequirementClients) ||
    hasOrganizationPermission(Manage, Scoring) ||
    hasOrganizationPermission(Read, ContractorReviews) ||
    hasOrganizationPermission(Read, ActivityFeed);

  return (
    <React.Fragment>
      {features.includes(VeriforceConnect) && <Connect organization={organization as IOrganization} />}
      {showContractorManagementSection && !isChasClient && (
        <ContractorManagementSectionContainer organization={organization} />
      )}
      {features.includes(Esignature) && <EsignatureContainer organizationId={organization.id} location={location} />}
      {features.includes(OrganizationFeature.VerisourceContractorOQNavigation) ||
      features.includes(OrganizationFeature.VerisourceEmployeeOQNavigation) ? (
        <VerisourceOQNavigation organization={organization} client={true} />
      ) : null}
      {hasOrganizationPermission(Read, Reports) && !isChasClient && (
        <ReportsSectionContainer organizationId={organization.id} location={location} />
      )}
      {!isChasClient && <TrainingSection organization={organization} />}
      {organization.features.includes(Subcontractor) &&
        organization.features.includes(OrganizationFeature.Client) &&
        hasOrganizationPermission(Read, Subcontractors) && (
          <SubcontractorManagementContainer organization={organization} />
        )}
    </React.Fragment>
  );
};
